import { createContext } from 'react';

export type ThemeName = 'default' | 'charcoal' | 'obsidian';

// Central list driving ThemePicker's rendered options. Adding a theme means
// adding one entry here (plus its ThemeName union member) — see
// resolveThemeClass in ThemeContext.tsx for the matching naming contract.
export const THEME_OPTIONS: Array<{ label: string; value: ThemeName }> = [
  { label: 'Default', value: 'default' },
  { label: 'Charcoal', value: 'charcoal' },
  { label: 'Obsidian', value: 'obsidian' },
];

export interface ThemeContextType {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  themeName: ThemeName;
  setThemeName: (name: ThemeName) => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
